import React from "react";

const PracticeHospitalAffiliations = (props) => {
    if(props.hospitals === undefined || props.hospitals.length === 0) {
        return <p>No hospitals affiliated</p>
    }

    const hospitalItems = props.hospitals.map((hospital, index) => {
        return <li key={hospital.id}>{hospital.name}</li>
    });
    return (
        <ul>
            {hospitalItems}
        </ul>
    );
};

export default PracticeHospitalAffiliations;